import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { AdminRequests } from "@tfg/types/endpoints/admin"

import { httpClient } from "~/backend/axios"
import { downloadFile } from "~/utils/downloadFile"

type useExportBouncedEmailsRequest = Omit<
  AdminRequests.findBouncedEmailsRequest,
  "fetchDataOptions"
>
export const useExportBouncedEmails = ({
  filters,
}: useExportBouncedEmailsRequest) => {
  return useMutation<string, AxiosError, void>(["bouncedEmails"], async () => {
    const response = await httpClient.get<string>(
      "/admin/traceability/export-all-bounced-emails",
      {
        params: {
          filters,
        },
      }
    )
    downloadFile(
      response.data,
      `bounced-emails_${new Date().toJSON().slice(0, 10)}.csv`,
      "text/csv"
    )
    return response.data
  })
}
